/* ═══════════════════════════════════════════════════════════════
   HX-16/D · HEROX Cart Drawer — logika (wdrożenie referencji Claude Design)
   Dane renderuje Liquid (sections/hx-cart-drawer.liquid); tutaj: otwieranie,
   timer, karuzela upsell oraz mutacje przez Cart AJAX API + Section Rendering API.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var SECTION = 'hx-cart-drawer';
  var CHECKOUT_URL = '/checkout';

  function $(id) { return document.getElementById(id); }
  function cartEl() { return $('hxCart'); }
  function wrapEl() { return $('shopify-section-' + SECTION); }
  function isOpen() { var c = cartEl(); return !!(c && c.classList.contains('is-open')); }

  function open() {
    var c = cartEl();
    if (!c) return;
    c.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    var c = cartEl();
    if (!c) return;
    c.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  window.hxCartOpen = function () { open(); refreshSections(); };
  window.hxCartClose = close;

  /* ── podmiana sekcji (Section Rendering API) ── */
  function applySections(sections) {
    if (!sections) return false;
    var html = sections[SECTION];
    if (typeof html !== 'string') return false;
    var w = wrapEl();
    if (!w) return false;
    var wasOpen = isOpen();
    w.innerHTML = html;                 // <script>/<style> z innerHTML się nie wykonują — brak podwójnej inicjalizacji
    if (wasOpen) open();
    initRender();
    return true;
  }
  function refreshSections() {
    return fetch(location.pathname + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { applySections(j); })
      .catch(function () { });
  }

  /* ── mutacje koszyka ── */
  function mutateJSON(url, body) {
    body.sections = SECTION;
    body.sections_url = location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (!applySections(data && data.sections)) refreshSections(); return data; })
      .catch(function () { refreshSections(); });
  }

  // Dodawanie do koszyka (JSON) — używane przez upsell i przez window.hxAddToCart (PDP/kolekcje).
  window.hxCartAdd = function (items) {
    open(); // optymistycznie
    return mutateJSON('/cart/add.js', { items: items }).then(function (d) { open(); return d; });
  };
  // Zgodność wsteczna: dawni wołający (hx-pdp) używają window.hxAddToCart.
  window.hxAddToCart = function (items) { return window.hxCartAdd(items); };

  // Dodawanie z formularza (PDP/kolekcje Horizon) — zachowuje properties/warianty.
  function addForm(form) {
    var fd = new FormData(form);
    fd.append('sections', SECTION);
    fd.append('sections_url', location.pathname);
    open();
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (!applySections(data && data.sections)) refreshSections(); open(); })
      .catch(function () { refreshSections(); });
  }

  /* ── timer rezerwacji (deadline w sessionStorage, przeżywa re-render) ── */
  var timerT = null;
  function initTimer() {
    if (timerT) { clearTimeout(timerT); timerT = null; }
    var el = $('hxTimer');
    if (!el) return;
    var seconds = parseInt(el.getAttribute('data-seconds'), 10) || 0;
    if (!seconds) { el.textContent = ''; return; }
    var KEY = 'hxReserveDeadline';
    var dl = parseInt(sessionStorage.getItem(KEY), 10);
    if (!dl || dl < Date.now()) {
      dl = Date.now() + seconds * 1000;
      try { sessionStorage.setItem(KEY, String(dl)); } catch (e) { /* noop */ }
    }
    (function tick() {
      var t = $('hxTimer');
      if (!t) return;
      var rem = Math.max(0, Math.round((dl - Date.now()) / 1000));
      var m = Math.floor(rem / 60), s = rem % 60;
      t.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (rem > 0 && isOpen()) { timerT = setTimeout(tick, 1000); }
      else if (rem > 0) { timerT = setTimeout(tick, 1000); }
    })();
  }

  /* ── karuzela upsell ── */
  var upIdx = 0, raf = null, tweening = false, settle = null;
  function rail() { return $('hxRail'); }
  function cards() { var r = rail(); return r ? r.querySelectorAll('.hx-up__card') : []; }
  function step() {
    var r = rail(); if (!r) return 0;
    var c = r.firstElementChild;
    return c ? c.getBoundingClientRect().width + 12 : r.clientWidth;
  }
  function renderDots() {
    var n = cards().length, d = $('hxDots');
    if (d) {
      var html = '';
      for (var i = 0; i < n; i++) html += '<i class="' + (i === upIdx ? 'is-active' : '') + '"></i>';
      d.innerHTML = html;
    }
    var p = $('hxUpPrev'), nx = $('hxUpNext');
    if (p) p.disabled = upIdx <= 0;
    if (nx) nx.disabled = upIdx >= n - 1;
  }
  // Uwaga: scrollTo({behavior:'smooth'}) bywa anulowany przez scroll-snap — ręczny tween.
  function tween(to) {
    var r = rail(); if (!r) return;
    if (raf) cancelAnimationFrame(raf);
    var from = r.scrollLeft, dur = 320, t0 = performance.now();
    tweening = true;
    (function frame(now) {
      var p = Math.min(1, (now - t0) / dur);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      r.scrollLeft = from + (to - from) * e;
      if (p < 1) raf = requestAnimationFrame(frame);
      else { tweening = false; raf = null; }
    })(t0);
  }
  function goUp(i, instant) {
    var r = rail(); if (!r) return;
    var n = cards().length;
    upIdx = Math.max(0, Math.min(n - 1, i));
    renderDots();
    var to = Math.min(upIdx * step(), r.scrollWidth - r.clientWidth);
    if (instant) r.scrollLeft = to; else tween(to);
  }
  function initCarousel() {
    var r = rail(); if (!r) return;
    upIdx = 0;
    renderDots();
    goUp(0, true);
    r.addEventListener('scroll', function () {
      if (tweening) return;
      clearTimeout(settle);
      settle = setTimeout(function () {
        var s = step(); if (!s) return;
        var i = Math.max(0, Math.min(cards().length - 1, Math.round(r.scrollLeft / s)));
        if (i !== upIdx) { upIdx = i; renderDots(); }
      }, 120);
    }, { passive: true });
  }

  function initRender() { initTimer(); initCarousel(); }

  /* ── delegacja zdarzeń (podpięta raz, przeżywa podmiany sekcji) ── */
  // Otwieranie: przechwyć w fazie capture, by ubiec inline onclick starego drawera.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.hx0n-cart, [data-testid="cart-drawer-trigger"], [data-hx-cart-open]');
    if (t) { e.preventDefault(); e.stopImmediatePropagation(); open(); refreshSections(); }
  }, true);

  // Dodawanie z formularza — capture, by ubiec handler Horizon (bez podwójnego add).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
      e.preventDefault(); e.stopImmediatePropagation();
      addForm(form);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target : e.target.parentElement;

    if (e.target.closest('[data-hx-cart-close]')) { close(); return; }

    var addBtn = e.target.closest('[data-hx-add]');
    if (addBtn) {
      var vid = addBtn.getAttribute('data-variant-id');
      if (vid) {
        addBtn.disabled = true; addBtn.textContent = 'Dodaję…';
        window.hxCartAdd([{ id: Number(vid), quantity: 1 }]);
      }
      return;
    }

    var qtyBtn = e.target.closest('[data-hx-qty]');
    if (qtyBtn) {
      var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
      var q = parseInt(qtyBtn.getAttribute('data-q'), 10);
      if (line > 0 && q >= 0) mutateJSON('/cart/change.js', { line: line, quantity: q });
      return;
    }

    var rmBtn = e.target.closest('[data-hx-rm]');
    if (rmBtn) {
      var rl = parseInt(rmBtn.getAttribute('data-line'), 10);
      if (rl > 0) mutateJSON('/cart/change.js', { line: rl, quantity: 0 });
      return;
    }

    if (e.target.closest('[data-checkout]')) { window.location.href = CHECKOUT_URL; return; }

    if (e.target.closest('#hxUpPrev')) { goUp(upIdx - 1); return; }
    if (e.target.closest('#hxUpNext')) { goUp(upIdx + 1); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
    if (!isOpen()) return;
    if (e.target && e.target.id === 'hxRail') {
      if (e.key === 'ArrowRight') { e.preventDefault(); goUp(upIdx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goUp(upIdx - 1); }
    }
  });

  /* ── start ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRender);
  } else {
    initRender();
  }
})();
